import { FC } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { colors, formatXAxis, formatYAxis, IAiChart, IStackedAreaConfig } from "./chartConfig";
import { customTokens } from "../../theme/theme";

const AiStackedAreaChart: FC<IAiChart> = ({ config, chartData }) => {
  const { data } = config as IStackedAreaConfig;

  const xKey = data.x.field;
  const xLabel = data.x.label;

  const yKey = data.y.field;
  const yLabel = data.y.label;

  const stackKey = data.stack?.field;

  let transformedData = chartData;
  let stackValues: string[] = [];

  if (stackKey) {
    stackValues = Array.from(new Set(chartData.map((d) => d[stackKey])));

    transformedData = chartData.reduce((acc: any[], curr) => {
      const existing = acc.find((item) => item[xKey] === curr[xKey]);
      if (existing) {
        existing[curr[stackKey]] = curr[yKey];
      } else {
        acc.push({
          [xKey]: curr[xKey],
          [curr[stackKey]]: curr[yKey],
        });
      }
      return acc;
    }, []);
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <AreaChart
        data={transformedData}
        margin={{ left: 40, right: 25 }}
      >
        <CartesianGrid
          stroke={customTokens.colorNeutralBackground4}
          horizontal={true}
          vertical={false}
        />

        <XAxis
          tickFormatter={(v) => formatXAxis(v)}
          dataKey={xKey}
          axisLine={false}
          tickLine={false}
          interval={0}
          label={{
            value: xLabel,
            position: "bottom",
            style: {
              textAnchor: "middle",
              fontWeight: 700,
              fill: customTokens.fontDarkGrayBody,
            },
          }}
        />

        <YAxis
          tickFormatter={(v) => formatYAxis(v)}
          axisLine={false}
          tickLine={false}
          label={{
            value: yLabel,
            angle: -90,
            position: "insideLeft",
            offset: -20,
            style: {
              textAnchor: "middle",
              fontWeight: 700,
              fill: customTokens.fontDarkGrayBody,
            },
          }}
        />

        <Tooltip formatter={(v) => formatYAxis(v)} />

        <Legend iconType="circle" wrapperStyle={{ paddingTop: 30 }} />

        {stackKey ? (
          stackValues.map((s, idx) => (
            <Area
              key={s}
              dataKey={s}
              name={s}
              stackId="1"
              fill={colors[idx % colors.length]}
              stroke={colors[idx % colors.length]}
              strokeWidth={2}
            />
          ))
        ) : (
          <Area
            dataKey={yKey}
            stroke={customTokens.UNFCCCBrandGraphLevel1}
            fill={customTokens.UNFCCCBrandGraphLevel1}
            strokeWidth={2}
          />
        )}
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default AiStackedAreaChart;
